export function hexToRgbWithOpacity(hex, opacity) {
  // Remove '#' if present
  hex = hex.replace(/^#/, '');

  // Handle shorthand hex (e.g., #FFF)
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }

  // Parse hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Validate opacity (0-1 range)
  const alpha = Math.min(1, Math.max(0, opacity));

  // Return as rgba
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}